import React, { useEffect } from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Welcome from './pages/welcome/Welcome';
import ParticipatingOrganisations from './pages/participating-organisations/ParticipatingOrganisations';
import About from './pages/about/About';
import TermsConditions from './pages/terms-conditions/TermsConditions';
import Privacy from './pages/privacy/Privacy';
import SupportService from 'pages/support-service/SupportService';
import FindingInformation from 'pages/finding-information/FindingInformation';
import ContactUs from 'pages/contact-us/contactUs';
import JoinService from 'pages/join-service/JoinService';
import ImportHotjar from './customHooks/importHotjar';
import { getParticipatingOrganisationData } from '../src/redux/actions';
import HelpCentre from 'pages/help-centre/Help-centre';

import DeathCheck from './pages/death-check/DeathCheck';
import DeceasedInfo from './pages/deceased-info/DeceasedInfo';
import SelectOrgs from './pages/select-orgs/SelectOrgs';
import ContactDetails from './pages/contact-details/ContactDetails';
import ConfirmNotify from './pages/confirm-notify/ConfirmNotify';
import Finished from './pages/finished/Finished';

const App = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getParticipatingOrganisationData());
  }, []);
  dispatch(getParticipatingOrganisationData());

  const hotjar = ImportHotjar();

  return (
    <Switch>
      <Route path="/" exact component={Welcome} />
      <Route path="/welcome" exact component={Welcome} />
      <Route path="/qr" exact component={Welcome} />
      <Route path="/participating-organisations" exact component={ParticipatingOrganisations} />
      <Route path="/about" exact component={About} />
      <Route path="/support" exact component={SupportService} />
      <Route path="/terms-conditions" exact component={TermsConditions} />
      <Route path="/privacy" exact component={Privacy} />
      <Route path="/finding-information" exact component={FindingInformation} />
      <Route path="/contact-us" exact component={ContactUs} />
      <Route path="/join-service" exact component={JoinService} />
      <Route path="/help-centre" exact component={HelpCentre} />
      <Route path="/death-check" exact component={DeathCheck} />
      <Route path="/deceased-info" exact component={DeceasedInfo} />
      <Route path="/select-orgs" exact component={SelectOrgs} />
      <Route path="/contact-details" exact component={ContactDetails} />
      <Route path="/confirm-notify" exact component={ConfirmNotify} />
      <Route path="/finished" exact component={Finished} />
    </Switch>
  );
};

export default withRouter(App);
